import TagsScreen from "../modules/tags/TagsScreen"

export default function Tags() {
  return (
    <>
      <TagsScreen />
    </>
  )
}
